import { STORAGE_KEYS, StorageService } from './services/storage.service';
import { Component, OnInit, OnDestroy, inject, signal } from '@angular/core';
import { SettlementsService } from './services/settlements.service';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { ImageService } from './shared/services/image.service';
import { AuthService } from './shared/services/auth.service';
import { User } from './models/user';
import { Profile } from './models/profile.model';

@Component({
  selector: 'app-root',
  template: `
    <app-navbar 
      *ngIf="user" 
      [user]="user" 
      [profileLogo]="profileLogo"
    ></app-navbar>
    <div class="d-flex clearfix">
      <div class="d-none d-sm-none d-md-block section__sidebar" [class.hidden]="loginHidden()">
        <app-sidebar 
          *ngIf="user" 
          [user]="user" 
          [profile]="profile" 
          [profileLogo]="profileLogo"
        ></app-sidebar>
      </div>
      <div class="main-container flex-fill m-md-3 mb-0 section__mainContent" 
        [ngClass]="user ? 'mx-3 my-3' : ''" 
        role="main" 
        (window:resize)="onResize($event)"
      >
        <router-outlet></router-outlet>
      </div>
    </div>
    <app-nav-tenant-bottom 
      *ngIf="user" 
      [user]="user"
    ></app-nav-tenant-bottom>
    
    <!-- God Mode Toggle - Available on all screens when user is logged in -->
    <app-god-mode-toggle *ngIf="user"></app-god-mode-toggle>
    
    <!-- app-notify-floater></app-notify-floater -->
    <!-- div *ngIf="role?.group_id != 3">
      <app-video-player [profile]="profile" [permissions]="permissions"></app-video-player>
    </!-->
  `,
  styleUrls: []
})
export class AppComponent implements OnInit, OnDestroy {
  private routerSubscription: Subscription;
  private apiUrl: string = 'https://api.zazz.mx'; // environment.AWS_REST_WSPREFIX;
  protected version = environment.app_version;
  storageService = inject(StorageService);

  ux: any = sessionStorage.getItem(STORAGE_KEYS.USER) ? JSON.parse(sessionStorage.getItem(STORAGE_KEYS.USER)!) : {};
  user: User = this.ux;
  profile: Profile = sessionStorage.getItem(STORAGE_KEYS.PROFILE) ? JSON.parse(sessionStorage.getItem(STORAGE_KEYS.PROFILE)!) : {};
  profiles: any = [];
  role: any = {};  
  profileLogo: any = '';

  superadmin: boolean = false;
  avatarURL: string = '';
  avatarLS: any = null;
  loginHidden = signal<boolean>(false);
  constructor(
    private store: SettlementsService,
    private router: Router,
    private imgService: ImageService,
    private authService: AuthService
  ) {
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.loginHidden.update(() => this.router.url.includes('ingresar'));
        this.ux = this.storageService.getItem(STORAGE_KEYS.USER);
        this.user = this.ux;
        this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;

        if (this.user) {
          this.authService.loadUserPermissions(this.user.id);
        }

        this.superadmin = this.role.id == 1 ? true : false;

        if (this.profile != null) {
          this.profileLogo = this.profile.logo; //  != null ? this.imgService.buildURL(this.profile.logo) : 'assets/images/logo-zazz.png';
          this.loadProfiles();

          if (this.avatarLS == null) {
            this.store.getUser(this.user.id).subscribe((data: any) => {
              let el = data.avatar;
              if (el != null) {
                this.avatarURL = `${this.apiUrl}/storage/${el.blob.key.substring(0,2)}/${el.blob.key.substring(2,4)}/${el.blob.key}`;
                this.storageService.saveItem(STORAGE_KEYS.AVATAR, { avatar: this.avatarURL});
              } else {
                this.avatarURL = 'assets/images/logo-zazz.png';
              }
            });
          } else {
            this.avatarLS = this.storageService.getItem(STORAGE_KEYS.AVATAR) ?? {};
          }
        }
      }
    });
  }

  ngOnInit(): void {}

  onResize(event: any) {}

  loadProfiles() {
    this.store.getProfiles({ page: 1, per_page: 100 }).subscribe({
      next: (data: any) => {
        console.log('profiles => ', data);
        this.profiles = data.data;
      },
      error: (e: any) => {}
    });
  }

  changeProfile(profile: any) {
    this.profile = profile;
    const currProfile = this.profiles.find((el: any) => profile.id == el.id);
    this.storageService.saveItem(STORAGE_KEYS.PROFILE, { profile: currProfile});
    this.storageService.removeItem(STORAGE_KEYS.PAYFILTERSPREFS);
    this.store.updateUser(this.user.id, { profile_id: profile.id }).subscribe({
      next: (data: any) => {
        this.storageService.saveItem(STORAGE_KEYS.USER, data);
        console.log('User updated with new profile:', data);
        this.router.navigate(['/dashboard']);
        // window.location.reload();
      }
    });    
  }

  signOut() {
    this.storageService.removeItem(STORAGE_KEYS.TOKEN);
    this.storageService.removeItem(STORAGE_KEYS.USER);
    this.storageService.removeItem(STORAGE_KEYS.PROFILE);
    this.storageService.removeItem(STORAGE_KEYS.AVATAR);
    this.storageService.removeItem(STORAGE_KEYS.PERMISSIONS);
    this.storageService.removeItem(STORAGE_KEYS.ROLE);
    this.router.navigate(['sign-in']);
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  dispatchHelp() {}
}
